<template>
  <ul class="navbar-nav">
    <li class="nav-item">
      <router-link class="nav-link" to="/dashboard">
        <!-- <i class="ni ni-tv-2"></i> {{ $i18n.t('global.dashboard') }} -->
        <i class="fas fa-home"></i> {{ $i18n.t('global.dashboard') }}
      </router-link>
    </li>
    <li class="nav-item">
      <router-link class="nav-link" to="/coins" :class="{'active': subIsActive('/coins')}">
        <i class="fas fa-coins"></i> {{ $i18n.t('global.coins') }}
      </router-link>
    </li>
    <li class="nav-item">
      <router-link class="nav-link" to="/banknotes" :class="{'active': subIsActive('/banknotes')}">
        <i class="far fa-money-bill-alt"></i> {{ $i18n.t('global.banknotes') }}
      </router-link>
    </li>
    <li class="nav-item">
      <!-- <router-link :to="{ name: '', params: {} }"></router-link> -->
      <router-link class="nav-link" to="/books" :class="{'active': subIsActive('/books')}">
        <!-- <i class="ni ni-books"></i> Books -->
        <i class="fas fa-book"></i> {{ $i18n.t('global.books') }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Nav',
  methods: {
    subIsActive (input) {
      const paths = Array.isArray(input) ? input : [input]
      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/Nav.vue